import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useTelegram } from '@/shared/hooks/useTelegram';

/** Фон приложения совпадает с --sg-bg-base из tokens.css. */
const HEADER_COLOR = '#061a1c';

/**
 * Синхронизация с Telegram-клиентом.
 *
 * Что здесь делается и почему:
 *  - цвет шапки и фона: без этого над приложением висит светлая полоса
 *    системного заголовка, и тёмное поле выглядит обрезанным;
 *  - BackButton показывается только там, где есть куда вернуться. Нижняя
 *    навигация — корневые экраны, у них кнопки «назад» быть не должно;
 *  - обработчик BackButton переустанавливается на каждый переход: иначе он
 *    закрывает приложение из глубины истории.
 */
export function TelegramBridge(): null {
  const { webApp, isTMA, setHeaderColor, setBackgroundColor } = useTelegram();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isTMA) return;
    setHeaderColor(HEADER_COLOR);
    setBackgroundColor(HEADER_COLOR);
  }, [isTMA, setHeaderColor, setBackgroundColor]);

  useEffect(() => {
    if (!isTMA || !webApp) return;

    const isRoot = ROOT_PATHS.has(location.pathname);
    const button = webApp.BackButton;

    if (isRoot) {
      button.hide();
      return;
    }

    const onBack = (): void => {
      // history.length > 1 не всегда верно в WebView (страница могла быть
      // открыта по deep link), поэтому фолбэк на корень.
      if (window.history.length > 1) navigate(-1);
      else navigate('/');
    };

    button.onClick(onBack);
    button.show();

    return () => {
      button.offClick(onBack);
      button.hide();
    };
  }, [isTMA, webApp, location.pathname, navigate]);

  return null;
}

/** Корневые экраны нижней навигации — «назад» из них некуда. */
const ROOT_PATHS = new Set(['/', '/bridge', '/games', '/profile', '/admin', '/auth']);
